<template lang="html">

    <section class="energia-alt sec-foto metal">
      <img class="w-100" src="/static/img/bkg/bkg-energia-alt.webp" :alt="$t('catalogo.alt_images.pila_hidrogeno')" width="1766" height="1179" loading="lazy">
      <div class="container waypoints flex row-reverse justify" data="fadeInRight">
        <div class="col-50 text-container">
          <a target="_blank" href="http://www.ajusath.es/"></a>
          <!-- Los niveles estaban invertidos: el h3 era el antetitulo pequeno y
               el h4 el titulo grande de la seccion. -->
          <p class="title-18">{{$t('catalogo.ajusa_th.intro')}}</p>
          <h2 class="title title-52">{{$t('catalogo.ajusa_th.titulo')}}</h2>
          <div v-html="$t('catalogo.ajusa_th.texto')"></div>
          <p class="go">{{$t('catalogo.ajusa_th.boton')}}<i class="fa-sharp fa-solid fa-arrow-right-long" ></i></p>
        </div>
      </div>
    </section>
</template>

<script lang="js">
  export default  {
    name: 'banner-ajusa-th',
    props: [],
    mounted() {

    },
    data() {
      return {
        showAjusath : false
      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped>
  .banner-ajusa-th {

  }
</style>



// WEBPACK FOOTER //
// src/components/parts/banner-ajusa-th.vue